module.exports = __webpack_public_path__ + "img/ekomi-approved.ebf1ec36.png";